import React from 'react'

import PrintQuestion from './PrintQuestion'
import {buildAnswerMap} from '../utils'

export default class PrintQuestionAnswers extends React.Component {

  printAllQuestions(questions, answers, originalAnswers) {
    return (
      <div className="scan-container">
        <h2>Scan</h2>
        {questions.coreQuestions.map((category, index) => (
          <div className="scan-section" key={index}>
            <h2>
              Fase {index + 1}: {category.headerText}
            </h2>

            {category.questions.map((question, i) => (
              <PrintQuestion
                key={i}
                question={question}
                state={answers}
                originalState={originalAnswers}
                completed={true}
                answermap={buildAnswerMap(questions, answers)}
              />
            ))}
          </div>
        ))}
      </div>
    )
  }

  render() {
    const { answers, originalAnswers, questions } = this.props

    return (
      <div className="questions-answers">
        {this.printAllQuestions(questions, answers, originalAnswers)}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PrintQuestionAnswers.js